var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "otp-verification",
      attrs: { "data-testid": "otp-verification" },
    },
    [
      _c("img", {
        staticClass: "mb-4",
        attrs: { src: require("../assets/logo.png"), width: "140" },
      }),
      _vm._v(" "),
      _vm.error
        ? _c(
            "v-alert",
            {
              staticClass: "otp-verification__error text-left",
              attrs: {
                color: "red",
                type: "error",
                "data-testid": "otp-verification__error",
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.error) + "\n  ")]
          )
        : _c(
            "div",
            {
              staticClass: "text-center mb-4",
              attrs: { "data-testid": "otp-verification__message" },
            },
            [
              _c("p", [_vm._v(_vm._s(_vm.$t("label.otp_sent")))]),
              _vm._v(" "),
              _c("p", { staticClass: "text-caption" }, [
                _vm._v(_vm._s(_vm.userEmail)),
              ]),
            ]
          ),
      _vm._v(" "),
      _c(
        "v-form",
        {
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c("v-text-field", {
            staticClass: "otp-verification__code",
            attrs: {
              placeholder: _vm.$t("field.otp_code"),
              "hide-details": "",
              type: "text",
              maxlength: "6",
              "data-testid": "otp-verification__code",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.verifyOtp.apply(null, arguments)
              },
              input: _vm.onOtpInput,
            },
            model: {
              value: _vm.model.otpCode,
              callback: function ($$v) {
                _vm.$set(_vm.model, "otpCode", $$v)
              },
              expression: "model.otpCode",
            },
          }),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "otp-verification__submit mb-5 mt-4",
              attrs: {
                color: "primary",
                large: "",
                block: "",
                disabled: _vm.verifying || !_vm.isValidOtp,
                loading: _vm.verifying,
                "data-testid": "otp-verification__submit",
              },
              on: { click: _vm.verifyOtp },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.$t("button.verify")) + "\n      "),
              _c("v-icon", { attrs: { dark: "", right: "" } }, [
                _vm._v("fa-check-circle"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "mb-5",
          attrs: { text: "", "data-testid": "otp-verification__back" },
          on: { click: _vm.goBackToSignIn },
        },
        [
          _c("v-icon", { attrs: { left: "" } }, [_vm._v("fa-arrow-left")]),
          _vm._v("\n    " + _vm._s(_vm.$t("button.back_to_signin")) + "\n  "),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }